import styles from './ContentCard.module.scss';

/**
 * ContentCard 컴포넌트
 * - 페이지 콘텐츠 영역을 감싸는 카드 형태의 공용 컴포넌트
 * - Figma Rectangle 3467482 스타일 적용 (둥근 모서리 15px, 그림자)
 */
export default function ContentCard({ children, className }) {
  const cardClassName = className ? `${styles.contentCard} ${className}` : styles.contentCard;

  return <div className={cardClassName}>{children}</div>;
}
